import gql from 'graphql-tag'

const GET_USER_PERMISSIONS = gql`
  query userPermissions($tenantId: Int!) {
    userPermissions(tenantId: $tenantId)
  }
`

export { GET_USER_PERMISSIONS }
